module.exports = __webpack_public_path__ + "img/embaixador.ae2bb203.png";